webpackJsonp([177890977751730],{

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PolicyPage = function PolicyPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "post" },
	    _react2.default.createElement(
	      "h2",
	      { className: "title" },
	      "Hunting Policy"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "entry" },
	      _react2.default.createElement(
	        "p",
	        null,
	        "We will make sure you get within a comfortable shooting distance to harvest your animal. We will estimate the size and cost of the animal you are interested in. The final decision whether to harvest or not will be entirely your choice. After the animal is harvested if it does not score within your trophy class range the price will be adjusted to the appropriate level. The antlers will be green scored in your presence according to SCI guidelines. This score will determine the price and cannot be changed."
	      )
	    ),
	    _react2.default.createElement(
	      "h2",
	      { className: "title" },
	      "Health Policy"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "entry" },
	      _react2.default.createElement(
	        "p",
	        null,
	        "DreamCatcher hunting ranch will not be responsible for hunting accidents, health risks associated with hunting or expenses incurred because of these things. We do our best to make sure you have a safe and successful hunt. We reserve the right to cancel any hunt because of dangerous or irresponsible actions by our guests."
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "error" },
	        "Please advise or contact us of any special health or medical needs and concerns prior to your hunts."
	      )
	    )
	  );
	};
	
	exports.default = PolicyPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-policy-js-689d705fda0369601184.js